import { useParams } from 'react-router'
import { PramsKeys } from 'src/types/type'

export const useTelList = () => {
  const { pcode } = useParams<PramsKeys>()
  const ktPCodes = ['ktpass_01', 'ktpass_02', 'ktpass_03']
  const sktPCodes = ['sktpass_01', 'sktpass_02', 'sktpass_03']

  switch (true) {
    case ktPCodes.includes(pcode as string):
      return [{ idx: 1, text: 'kt' }]
    case sktPCodes.includes(pcode as string):
      return [{ idx: 0, text: 'skt' }]
    default:
      return [
        { idx: 0, text: 'skt' },
        { idx: 1, text: 'kt' },
        { idx: 2, text: 'lg' },
      ]
  }
}
